module.exports = __webpack_public_path__ + "static/media/menu-icon-challenge.f825542b.png";